import React, { useState, useEffect } from 'react';
import { useNotifications } from '../../../contexts/NotificationContext';
import { hapticFeedback } from '../../../utils/telegram';
import './Notifications.css';

const Notifications = () => {
  const { 
    notifications, 
    unreadCount, 
    markAsRead, 
    markAllAsRead,
    refreshNotifications 
  } = useNotifications();
  
  const [showNotifications, setShowNotifications] = useState(false);

  // Add/remove class to body when notifications panel opens/closes
  useEffect(() => {
    if (showNotifications) {
      document.body.classList.add('notifications-open');
    } else {
      document.body.classList.remove('notifications-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('notifications-open');
    };
  }, [showNotifications]);

  const handleNotificationClick = () => {
    hapticFeedback.light();
    setShowNotifications(!showNotifications);
    // Обновляем список уведомлений при открытии панели
    if (!showNotifications) {
      refreshNotifications();
    }
  };

  const handleCloseNotifications = () => {
    hapticFeedback.light();
    setShowNotifications(false);
  };

  // Handle individual notification click
  const handleNotificationRead = async (notificationId, event) => {
    // Предотвращаем всплытие события клика, чтобы не закрывать панель
    event.stopPropagation();
    
    try {
      hapticFeedback.light();
      await markAsRead(notificationId);
    } catch (error) {
      console.error('Failed to mark notification as read:', error);
      hapticFeedback.error();
    }
  };
  
  // Handle mark all as read button click
  const handleMarkAllAsRead = (event) => {
    // Предотвращаем всплытие события клика
    event.stopPropagation();
    
    if (unreadCount > 0) {
      hapticFeedback.light();
      markAllAsRead();
    }
  };

  return (
    <div className="notifications-wrapper">
      <button className="icon-button notification" onClick={() => {
        hapticFeedback.light();
        handleNotificationClick();
      }}>
        <svg className="notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z" fill="currentColor"/>
        </svg>
        {unreadCount > 0 && <span className="notification-dot"></span>}
      </button>

      {showNotifications && (
        <>
          <div className="backdrop-overlay" onClick={() => {
            hapticFeedback.light();
            handleCloseNotifications();
          }}></div>
          <div className="notifications-panel">
            <div className="notifications-header">
              <h3>Уведомления</h3>
              <button className="close-button" onClick={() => {
                hapticFeedback.light();
                handleCloseNotifications();
              }}>
                ✕
              </button>
            </div>
            <div className="notifications-divider"></div>
            <div className="notifications-list">
              {notifications.length === 0 ? (
                <div className="empty-notifications">У вас нет уведомлений</div>
              ) : (
                notifications.map(notification => (
                  <div 
                    key={notification._id} 
                    className={`notification-item ${notification.read ? '' : 'unread'}`}
                    onClick={(event) => handleNotificationRead(notification._id, event)}
                  >
                    <div className="notification-marker"></div>
                    <div className="notification-content">
                      <div className="notification-title">{notification.title}</div>
                      <div className="notification-message">{notification.message}</div>
                      <div className="notification-time">
                        {new Date(notification.createdAt).toLocaleString()}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            <div className="notifications-footer">
              <button 
                className="mark-all-read" 
                onClick={(event) => {
                  if (notifications.length > 0) {
                    hapticFeedback.light();
                  }
                  handleMarkAllAsRead(event);
                }}
                disabled={notifications.length === 0}
              >
                Отметить все как прочитанные
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Notifications; 